const React = require('react');
const client = require('./client');

module.exports = function usePartyPlayer(video, params) {
    const previous = React.useRef({});
    const autoPaused = React.useRef(false);
    const lastStream = React.useRef(null);
    const lastParty = React.useRef(null);
    React.useEffect(() => client.subscribe(() => {
        if (client.party?.code && client.party.code !== lastParty.current && client.player?.state.stream) {
            client.broadcast('go', ['player', { stream: client.player.state.stream, type: params.type, id: params.id, videoId: params.videoId }]);
            client.publishState();
        }
        lastParty.current = client.party?.code;
    }), [params.type, params.id, params.videoId]);
    React.useEffect(() => {
        client.player = video;
        client.applyState();
        const s = video.state;
        if (s.stream && s.stream !== lastStream.current) {
            client.broadcast('go', ['player', { stream: s.stream, type: params.type, id: params.id, videoId: params.videoId }]);
            lastStream.current = s.stream;
        }
        const p = previous.current;
        if (client.isLeader() && Date.now() >= client.suppressUntil) {
            if (s.buffering && !p.buffering && s.paused === false) {
                autoPaused.current = true; video.setPaused(true);
            } else if (!s.buffering && p.buffering && autoPaused.current) {
                autoPaused.current = false; video.setPaused(false);
            }
        }
        if (s.paused !== p.paused || s.playbackSpeed !== p.playbackSpeed ||
            (Number.isFinite(p.time) && Math.abs(s.time - p.time) > 2000)) client.publishState();
        previous.current = s;
    });
    React.useEffect(() => {
        const timer = setInterval(() => { if (client.isLeader()) client.publishState(); }, 5000);
        return () => { clearInterval(timer); client.player = null; };
    }, []);
};
